var _path, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 111,
    viewBox: "0 0 118 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0204 108.5C88.5311 108.5 112.541 85.0423 112.541 56C112.541 26.9577 88.5311 3.5 59.0204 3.5C29.5098 3.5 5.5 26.9577 5.5 56C5.5 85.0423 29.5098 108.5 59.0204 108.5Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2214_90190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 103,
    height: 100
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.0204,
    cy: 56,
    rx: 51.0204,
    ry: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2214_90190)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 47.5,
    r: 21.5,
    fill: "#40484D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 74,
    width: 74,
    height: 42,
    rx: 21,
    fill: "#40484D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.75d78d1f5a66da00f88b45fa14d4ff0a.svg";
export { ForwardRef as ReactComponent };